import { toast } from "sonner";
import type { CognitoUserAttributes } from "@/atoms/userAtom";

/**
 * 認証関連のエラーメッセージ
 */
export const AUTH_ERROR_MESSAGES = {
  LOGIN_REQUIRED: "ログインが必要です。この機能を使用するにはアカウントにログインしてください。",
  SESSION_EXPIRED: "セッションの有効期限が切れました。再度ログインしてください。",
  AUTH_ERROR: "認証エラーが発生しました。問題が続く場合は管理者にお問い合わせください。",
  USER_ID_MISSING: "ユーザー情報の取得に失敗しました。再度ログインしてください。"
} as const;

/**
 * ユーザーが認証されているかチェック
 */
export const isAuthenticated = (
  user: CognitoUserAttributes | null
): user is CognitoUserAttributes & { userId: string } => {
  return user !== null && !!user.userId;
};

/**
 * 認証が必要な処理の前にチェックを行う
 * @param user - ユーザー情報
 * @param showToast - エラートーストを表示するか（デフォルト: true）
 * @returns 認証されている場合はtrue
 */
export const requireAuth = (user: CognitoUserAttributes | null, showToast = true): boolean => {
  if (!isAuthenticated(user)) {
    if (showToast) {
      toast.error(AUTH_ERROR_MESSAGES.LOGIN_REQUIRED);
    }
    return false;
  }
  return true;
};

/**
 * 認証エラーをハンドリング
 * @param error - エラーオブジェクト
 * @param context - エラーが発生したコンテキスト（デバッグ用）
 */
export const handleAuthError = (error: unknown, context?: string): void => {
  console.error(`Authentication error${context ? ` in ${context}` : ""}:`, error);

  // セッション切れの可能性がある場合
  if (error instanceof Error && error.message.includes("session")) {
    toast.error(AUTH_ERROR_MESSAGES.SESSION_EXPIRED);
  } else {
    toast.error(AUTH_ERROR_MESSAGES.AUTH_ERROR);
  }
};
